import { createRootRoute, Outlet } from '@tanstack/react-router';
import { DialogsProvider } from '@toolpad/core/useDialogs';

export const Route = createRootRoute({
  component: () => {
    return (
      <DialogsProvider>
        <Outlet />
        {/* <TanStackRouterDevtools /> */}
      </DialogsProvider>
    );
  },
});
